import { render, staticRenderFns } from "./Sopa.vue?vue&type=template&id=a9b3ff0c&scoped=true&"
import script from "./Sopa.vue?vue&type=script&lang=js&"
export * from "./Sopa.vue?vue&type=script&lang=js&"
import style0 from "./Sopa.vue?vue&type=style&index=0&id=a9b3ff0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b3ff0c",
  null
  
)

export default component.exports